import { useEffect } from "react";

/**
 * Closes an openable (header menu, modal, etc.) when Escape is pressed.
 */
export function useCloseOpenableOnEscape(isOpen: boolean, close: () => void): void {
	useEffect(() => {
		if (!isOpen) {
			return undefined;
		}
		const handleKeyDown = (event: KeyboardEvent): void => {
			if (event.key === "Escape") {
				close();
			}
		};
		document.addEventListener("keydown", handleKeyDown);
		return (): void => {
			document.removeEventListener("keydown", handleKeyDown);
		};
	}, [close, isOpen]);
}
